import LTR from "@brand-icons/ploom/ui-info-circle-solid/ui-info-circle-solid-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiInfoCircleSolidIcon = iconFactory("UiInfoCircleSolidIcon", LTR);
